import React from "react";
import {
  Award,
  Ban,
  CalendarCheck,
  Check,
  CircleCheck,
  Download,
  Eye,
  FileDown,
  Loader2,
  LogOut,
  PackagePlus,
  Pencil,
  Printer,
  Receipt,
  ShieldCheck,
  ShieldX,
  Trash2,
  Undo2,
  UserPlus,
  ListChecks,
  X,
} from "lucide-react";
import { GlobalButton } from "./forms/GlobalFormFields";

const ACTION_PRESETS = {
  view: { Icon: Eye, label: "View", variant: "ghost" },
  edit: { Icon: Pencil, label: "Edit", variant: "ghost" },
  delete: { Icon: Trash2, label: "Delete", variant: "danger" },
  remove: { Icon: Trash2, label: "Remove", variant: "danger" },
  deactivate: { Icon: Ban, label: "Deactivate", variant: "danger" },
  activate: { Icon: CircleCheck, label: "Activate", variant: "ghost" },
  preview: { Icon: Eye, label: "Preview", variant: "ghost" },
  assign: { Icon: UserPlus, label: "Assign", variant: "ghost" },
  print: { Icon: Printer, label: "Print", variant: "ghost" },
  slip: { Icon: Printer, label: "Print slip", variant: "ghost" },
  exit: { Icon: LogOut, label: "Exit", variant: "ghost" },
  approve: { Icon: Check, label: "Approve", variant: "ghost" },
  reject: { Icon: X, label: "Reject", variant: "danger" },
  receipt: { Icon: Receipt, label: "Receipt", variant: "ghost" },
  download80g: { Icon: FileDown, label: "Download 80G certificate", variant: "ghost" },
  allocate: { Icon: PackagePlus, label: "Allocate", variant: "ghost" },
  return: { Icon: Undo2, label: "Mark as returned", variant: "ghost" },
  status: { Icon: ListChecks, label: "Update status", variant: "ghost" },
  certificate: { Icon: Award, label: "Download certificate", variant: "ghost" },
  download: { Icon: Download, label: "Download", variant: "ghost" },
  followUpComplete: {
    Icon: CalendarCheck,
    label: "Mark follow-up completed",
    variant: "ghost",
  },
  verify: { Icon: ShieldCheck, label: "Mark verified", variant: "primary" },
  unverify: { Icon: ShieldX, label: "Not verified", variant: "ghost" },
};

export function GlobalTableActionButton({
  action,
  title,
  ariaLabel,
  onClick,
  disabled,
  loading = false,
  variant,
  className = "",
  iconSize = 14,
  type = "button",
  ...rest
}) {
  const preset = ACTION_PRESETS[action];
  if (!preset) {
    throw new Error(`Unknown table action: ${action}`);
  }

  const { Icon, label, variant: presetVariant } = preset;
  const resolvedTitle = title || label;
  const resolvedVariant = variant ?? presetVariant;

  return (
    <GlobalButton
      type={type}
      variant={resolvedVariant}
      size="sm"
      className={`ub-table-action-btn ${className}`.trim()}
      title={resolvedTitle}
      ariaLabel={ariaLabel || resolvedTitle}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <Loader2 size={iconSize} className="ub-table-action-btn__spinner" aria-hidden />
      ) : (
        <Icon size={iconSize} aria-hidden />
      )}
    </GlobalButton>
  );
}
